import { useEffect } from 'react';
import { chatSocket } from '@/services/chatSocket';

/** Keeps the app-wide chat socket open while someone is signed in, and closes it on logout. */
export function useChatSocketLifecycle(signedIn: boolean) {
  useEffect(() => {
    if (!signedIn) {
      chatSocket.stop();
      return;
    }
    chatSocket.start();
    return () => chatSocket.stop();
  }, [signedIn]);
}
